import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { PhaseTypeEnum } from '@vatos-pas/common';
import { useTimelineLogic } from './Timeline/useTimelineLogic';
import { MobileTimelineView } from './Timeline/MobileTimelineView';
import { DesktopTimelineView } from './Timeline/DesktopTimelineView';

interface TimelineProps {
  geoCoords?: [number, number] | null;
  geoAccuracy?: number | null;
  geoLoading?: boolean;
  requestLocation?: () => void;
  geoLocationError?: string;
  showBump?: (bumpType: PhaseTypeEnum) => boolean;
  getNextStatusText?: (theJob: any) => string;
}

export const Timeline: React.FC<TimelineProps> = props => {
  const isMobile = useMediaQuery('(max-width:960px)');

  const logic = useTimelineLogic(props);

  if (isMobile) {
    return <MobileTimelineView logic={logic} />;
  }

  return <DesktopTimelineView logic={logic} />;
};

export default Timeline;
